import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as _ from 'lodash';
import { ToastService } from 'ng-uikit-pro-standard';
import { debounceTime, filter } from 'rxjs/operators';
import { BodegaService } from 'src/app/services/bodega.service';
import { FamiliaService } from 'src/app/services/familia.service';
import { FormatoService } from 'src/app/services/formato.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { MovimientoStockService } from 'src/app/services/movimiento-stock.service';
import { ProductoService } from 'src/app/services/producto.service';
import { RubroService } from 'src/app/services/rubro.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { DatesService } from 'src/app/shared/services/dates.service';
import { FileDownloadService } from 'src/app/shared/services/file-download.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { RutService } from "src/app/shared/services/rut.service";
import { SecurityService } from 'src/app/shared/services/security.service';
import { ModalSeleccionarProductoComponent } from 'src/app/views/shared/modal-seleccionar-producto/modal-seleccionar-producto.component';

@Component({
  selector: 'app-movimiento-stock',
  templateUrl: './movimiento-stock.component.html',
  styleUrls: ['./movimiento-stock.component.scss'],
  providers: [SecurityService],
})
export class MovimientoStockComponent implements OnInit {

  // Modales
  @ViewChild(ModalSeleccionarProductoComponent, { static: true }) modalSeleccionarProducto: ModalSeleccionarProductoComponent

  // Form
  formHeader: FormGroup

  readonly TIPO_ACTIVO: Number = 10
  readonly TIPO_INACTIVO: Number = 11


  // Data & tmp
  private rutEmpresa: number
  private sucursalCodigo: number
  private currentPayload: any = null
  optionsRubro: Array<any> = [];
  optionsBodega: Array<any> = [];
  optionsFamilia: Array<any> = [];
  optionsFormato: Array<any> = [];
  loading: boolean = false
  listaMovimientos: Array<any> = null
  paginationContext: PaginationContext = new PaginationContext()
  productoSeleccionado: any = null
  conProducto: boolean = false

  // Utils
  private log: any

  constructor(
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private clog: ConsoleService,
    private bodegaService: BodegaService,
    private rubroService: RubroService,
    private familiaService: FamiliaService,
    private formatoService: FormatoService,
    private productoService: ProductoService,
    private movimientoStockService: MovimientoStockService,
    private messageRendererService: MessageRendererService,
    private toastService: ToastService,
    private fileDownloadService: FileDownloadService,
    private datesService: DatesService,
    private rutService: RutService,
  ) {
    this.log = this.clog.log('MOVIMIENTO STOCK')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());
    this.paginationContext.RecordsByPage = 10

    this.createForm()
    this.formChangesSubscriptions()
    this.loadBodegas()
    this.loadRubros()
    this.loadFormatos()
  }

  private createForm() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth()
    this.formHeader = this.fb.group({
      fechaDesde: [initDate, [Validators.required]],
      fechaHasta: [currentDate, [Validators.required]],
      bodega: [[]],
      rubro: [[]],
      familia: [[]],
      formato: [[]],
      mayorCero: [true],
      igualCero: [true],
      activo: [this.TIPO_ACTIVO],
      sku: [null],
      incluirMovDemanda: [true]
    });
  }

  formChangesSubscriptions() {
    this.formHeader.get("sku").valueChanges
      .pipe(filter(Boolean), debounceTime(500))
      .subscribe((codigo: string) => {
        // const buscarInactivos = this.formHeader.get('activo').value === this.TIPO_INACTIVO;
        if (codigo && codigo.length > 2) {
          this.modalSeleccionarProducto.searchBySKU(codigo, true)
        }else{
          this.onProductoNoEncontrado()
        }
      })

    this.formHeader.get('activo').valueChanges.subscribe(() => {
      if (!this.productoSeleccionado) return;

      this.productoSeleccionado = null;
      this.formHeader.get('sku').setValue(null, { emitEvent: false });
      this.modalSeleccionarProducto.clearLast();      
    })

    this.formHeader.get("rubro").valueChanges.subscribe(() => {
      this.onRubroSelect()
    })
  }

  private loadBodegas() {
    this.bodegaService.GetBodegas(this.rutEmpresa, this.sucursalCodigo, ({ mensajes, respuesta }) => {
      const { registros } = respuesta
      this.optionsBodega = registros.map(bodega => ({ value: bodega.codigo, label: bodega.nombre, sucursal_codigo: bodega.sucursal_codigo, codigo: bodega.codigo }))
      this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('bodega'), this.optionsBodega)
    })
  }

  private loadRubros() {
    this.rubroService.obtenerRubros(this.rutEmpresa, ({ respuesta }) => {
      const { registros } = respuesta; //.registros.filter(p => p.estado);
      this.optionsRubro = registros.map(p => ({ value: p.codigo, label: p.descripcion }))
    })
  }

  onRubroSelect() {
    const listaRubros = this.formHeader.get('rubro').value || []
    this.optionsFamilia = []
    for (let i = 0; i < listaRubros.length; i++) {
      this.loadFamilias(listaRubros[i])
    }
  }

  private loadFamilias(codigoRubro: Number) {
    this.familiaService.obtenerFamiliaxRubro(this.rutEmpresa, codigoRubro, ({ respuesta }) => {
      const { registros } = respuesta; //.registros.filter(p => p.estado);
      let options = registros.map(p => ({ value: p.codigo, label: p.nombre }))
      this.optionsFamilia = this.optionsFamilia.concat(options)
    })
  }

  private loadFormatos() {
    this.formatoService.GetFormatosByCodigo(this.rutEmpresa, ({ respuesta }) => {
      const { registros } = respuesta;
      this.optionsFormato = registros.map(formato => ({
        value: formato.codigo, label:  `${formato.nombre} - ${formato.codigo}`
      }))
    })
  }

  openModalSeleccionarProducto() {
    const activo = this.formHeader.get('activo') && this.formHeader.get('activo').value === this.TIPO_ACTIVO;
    this.modalSeleccionarProducto.setActivoFilter(activo);
    this.modalSeleccionarProducto.show();
  }

  onProductoSeleccionado({ data: _productoSeleccionado }) {
    this.productoSeleccionado = _productoSeleccionado;
    
    if (!this.productoSeleccionado) return;

    const tipoEstado = _productoSeleccionado.activo ? this.TIPO_ACTIVO : this.TIPO_INACTIVO;
    this.formHeader.get('sku').setValue(_productoSeleccionado.sku, { emitEvent: false });
    this.formHeader.get('activo').setValue(tipoEstado, { emitEvent: false });

  }

  onProductoNoEncontrado(event?: any) {
    if (event && event.producto) {
      this.onProductoSeleccionado({ data: event.producto });
      return;
    }
    this.productoSeleccionado = null
  }

  buscar(pageNumber: number) {
    this.formValidatorsService.validateAllFormFields(this.formHeader)
    if (!this.formHeader.valid)
      return


    this.paginationContext.CurrentPage = pageNumber

    this.listaMovimientos = null
    if (this.productoSeleccionado === null) {
      this.conProducto = false
    } else {
      this.conProducto = true
    }

    const inputParams = {
      entidad: {
        rut_emisor: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        fecha_inico: this.formHeader.get('fechaDesde').value,
        fecha_final: this.formHeader.get('fechaHasta').value,
        sku: this.formHeader.get('sku').value ? this.formHeader.get('sku').value : '',
        mayorCero: this.formHeader.get('mayorCero').value,
        igualCero: this.formHeader.get('igualCero').value,
        producto_activo: this.formHeader.get('activo').value === this.TIPO_ACTIVO,
        listaBodega: this.formHeader.get('bodega').value,
        listaRubro: this.formHeader.get('rubro').value,
        listaFamilia: this.formHeader.get('familia').value,
        listaFormato: this.formHeader.get('formato').value,
        incluirMovDemanda: this.formHeader.get('incluirMovDemanda').value,
      },
      paginaActual: this.paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: this.paginationContext.RecordsByPage
    }

    this.currentPayload = _.cloneDeep(inputParams)

    this.log('inputParams', JSON.stringify(inputParams))

    this.loading = true
    this.movimientoStockService.obtenerReporteMovimientoStock(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta
      console.log('registros', registros)
      this.listaMovimientos = registros;
      this.paginationContext.RecordsCount = totalRegistros
      this.paginationContext.CurrentPage = paginaActual
      this.paginationContext.PagesCount = totalPaginas

      this.listaMovimientos.forEach(detalle => {
        detalle.rutFormato = this.rutService.AgregarDV(detalle.cliente_proveedor_rut)
      })
      this.loading = false
    })
  }

  onPageChange(context: PaginationContext) {
    this.buscar(context.RequestedPage)
  }

  exportarExcel() {
    const inputParams = _.cloneDeep(this.currentPayload)
    inputParams.entidad.retornaExcel = true
    delete inputParams.paginaActual
    delete inputParams.cantidadRegistrosPorPagina

    this.log('XLS', JSON.stringify(inputParams))

    this.movimientoStockService.obtenerReporteMovimientoStockExcel(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      if (respuesta)
        this.fileDownloadService.VerifyAndDownload(respuesta.registros[0].rutaArchivo)
    })
  }

  LimpiarData(){
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth()
    this.formHeader.reset();
    this.productoSeleccionado = null
    this.formHeader.get('fechaDesde').setValue(initDate);
    this.formHeader.get('fechaHasta').setValue(currentDate);
    this.formHeader.get("activo").setValue(this.TIPO_ACTIVO)
    this.formHeader.get("rubro").setValue([])
    this.formHeader.get("familia").setValue([])
    this.formHeader.get("formato").setValue([])
    this.formHeader.get("mayorCero").setValue(true)
    this.formHeader.get("igualCero").setValue(true)
    this.listaMovimientos = null
    this.loadBodegas();
  }
}
